export default __webpack_public_path__ + "static/media/HeartDiseaseUpdate_Awareness.f84a849c.pdf";